import { render, staticRenderFns } from "./DropdownBlock.vue?vue&type=template&id=b28ae242"
import script from "./DropdownBlock.vue?vue&type=script&lang=js"
export * from "./DropdownBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports